export var UNDEFINED = 'undefined';
export var FUNCTION = 'function';
export var OBJECT = 'object';
export var DEFAULT = 'default';
export var STRING = 'string';
export var SYMBOL = 'symbol';
export var SCRIPT = 'script';